import { AxiosInstance } from 'axios';

export interface Slot {
  date: string;
  startTime: string;
  endTime: string;
  accountIds: string[];
  credentialedName: string;
  avatarUrlDefault: string | null;
  avatarUrlSmall: string | null;
}

interface AvailabilityRequestProps {
  startTime: string;
  endTime: string;
  appointmentDurationMinutes: number;
  appointmentType: string;
  timeZone: string;
  memberId: string;
  providerAccountId?: string | null;
  providerRole?: string;
  createdAt?: string;
}

export const getAvailabilityDates = (
  axiosInstance: AxiosInstance,
  args: AvailabilityRequestProps,
) => {
  return axiosInstance
    .get('/availability', {
      params: {
        availability: {
          availability_type: 'dates',
          start_time: args.startTime,
          end_time: args.endTime,
          member_id: args.memberId,
          appointment_duration_minutes: `${args.appointmentDurationMinutes}`,
          appointment_type: args.appointmentType,
          time_zone: args.timeZone,
          created_at: args.createdAt,
          ...(!args.providerAccountId && args.providerRole && { provider_role: args.providerRole }),
          ...(args.providerAccountId && {
            provider_account_id: args.providerAccountId,
          }),
        },
      },
    })
    .then(d => d.data?.dates ?? []);
};

export const getAvailabilitySlots = (
  axiosInstance: AxiosInstance,
  args: AvailabilityRequestProps,
) => {
  return axiosInstance
    .get<{ slots: Slot[] }>('/availability', {
      params: {
        availability: {
          availability_type: 'slots',
          start_time: args.startTime,
          end_time: args.endTime,
          member_id: args.memberId,
          appointment_duration_minutes: `${args.appointmentDurationMinutes}`,
          appointment_type: args.appointmentType,
          time_zone: args.timeZone,
          ...(!args.providerAccountId &&
            args.providerRole && { provider_role: args.providerRole }),
          ...(args.providerAccountId && {
            provider_account_id: args.providerAccountId,
          }),
        },
      },
    })
    .then(d => d.data.slots);
};
